<div class="transaction-receipt-preview">
  <div class="receipt-preview-container">
    <div class="receipt-preview-header">
      <div class="receipt-preview-title">Receipt</div>
      <button
        id="receiptPreviewCloseBtn"
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="onClose()"></button>
    </div>

    <swiper-container
      #swiperContainer
      slides-per-view="1"
      space-between="20"
      centered-slides="true"
      pagination="true"
      keyboard="true"
      [attr.initial-slide]="initialSlide()"
      (swiperprogress)="onProgress($any($event))"
      (swiperslidechange)="onSlideChange($any($event))">
      @for (receipt of receipts(); track receipt.id; let i = $index) {
      <swiper-slide>
        <div class="receipt-container">
          @if (isSlideLoaded(i)) { @if (getFileType(receipt.url) === 'pdf') { @if (currentSlideIndex === i) {
          <div class="pdf-wrapper">
            <app-pdf-viewer [url]="calcConditionalEnvBasedUrl(receipt.url)"></app-pdf-viewer>
          </div>
          } } @else if (getFileType(receipt.url) === 'image') {
          <app-image-viewer [url]="calcConditionalEnvBasedUrl(receipt.url)"></app-image-viewer>
          } }
        </div>
      </swiper-slide>
      }
    </swiper-container>
  </div>
</div>
